export enum JobOptionTypeName {
    Standard = 0,
    Elevation = 1,
    ColorScheme = 2,
    BaseHouse = 3
}